import React from "react";
import AliceCarousel from "react-alice-carousel";

import ListItem from "../../ListItem";

const DealRestaurantsSlider = ({ onlyDealRestaurants, isMobile }) => (
  <>
    <div className={`little-extra item-${onlyDealRestaurants.length}`}>
      <div className="container">
        <h4>A Little Extra For You</h4>
        <AliceCarousel
          responsive={{ 0: { items: 1 }, 767: { items: 3 } }}
          startIndex={isMobile ? 0 : 1}
          infinite={!isMobile}
          dotsDisabled={true}
          stagePadding={{ paddingLeft: 0, paddingRight: isMobile ? 100 : 0 }}
        >
          {onlyDealRestaurants.map((restaurant, index) => (
            <ListItem
              key={restaurant.uid}
              restaurant={restaurant}
              index={index}
              isCustom={false}
              isReward={true}
              customTag=""
            />
          ))}
        </AliceCarousel>
      </div>
    </div>
    {/* little-extra */}
  </>
);

export default DealRestaurantsSlider;
